import { render, staticRenderFns } from "./FormPreview.vue?vue&type=template&id=b9470142&scoped=true"
import script from "./FormPreview.vue?vue&type=script&lang=js"
export * from "./FormPreview.vue?vue&type=script&lang=js"
import style0 from "./FormPreview.vue?vue&type=style&index=0&id=b9470142&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9470142",
  null
  
)

export default component.exports